import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useSharedState } from "state";
import PageLayout from "components/layout/page-layout";
import moment from "moment";
import Table, { tableHeader } from "components/table";
import { oneLine } from "components/table/table-parts";
import ActionButton from "components/table/action-btn";
import { IconFolderOpen } from "@tabler/icons-react";

export default function Budgets() {
  const { budgetRequests, getBudgetRequestsData, searchQuery, handleSearch, firstEntry } = useSharedState();

  const navigate = useNavigate();

  const [isFormLoading, setFormLoading] = useState<boolean>(false);
  const [lastFetchedPath, setLastFetchedPath] = useState<string>("");

  useEffect(() => {
    if (window.location.pathname === "/budgets" && lastFetchedPath !== window.location.pathname) {
      getBudgetRequestsData();
      setLastFetchedPath(window.location.pathname);
    }
  }, [window.location.pathname]);

  const onBudgetPageChange = async (offset: number) => {
    await getBudgetRequestsData(offset);
    await handleSearch(searchQuery, undefined, offset);
  };

  const budgetsTableHeaders: tableHeader[] = [
    { header_text: "№", narrow: true, wrap: false },
    { header_text: "Год", narrow: false, wrap: false },
    { header_text: "Компания", narrow: false, wrap: false },
    { header_text: "Отдел", narrow: false, wrap: false },
    { header_text: "Бюджет", narrow: false, wrap: false },
    { header_text: "Дата БО", narrow: false, wrap: false },
    { header_text: "Создатель", narrow: false, wrap: false },
    { header_text: "Действия", narrow: false, wrap: false },
  ];

  const budgetsList = (
    <>
      {budgetRequests.budget_requests.map((budget, index) => (
        <tr key={index}>
          <td>{oneLine((firstEntry + index).toString())}</td>
          <td>{oneLine(budget.year.toString() || "-")}</td>
          <td>{oneLine(budget.company || "-")}</td>
          <td>{oneLine(budget.department || "-")}</td>
          <td>{oneLine(budget.budget_type || "-")}</td>
          <td>{oneLine(moment(budget.request_date).format("DD.MM.YYYY") || "-")}</td>
          <td>{oneLine(budget.creator_name || "-")}</td>
          <td>
            <div className="btn-list flex-nowrap">
              <ActionButton
                icon={<IconFolderOpen className="icon" />}
                title="Подробнее"
                action={() => navigate(`${budget.budget_request_id}`)}
                color={"info"}
                modal={false}
              />
            </div>
          </td>
        </tr>
      ))}
    </>
  );

  const budgetsTableComponent = Table(budgetsTableHeaders, budgetsList, true, {
    total: budgetRequests.total_count,
    updateInfo: onBudgetPageChange,
  });

  return (
    <>
      <PageLayout
        children={budgetsTableComponent}
        header={"Бюджеты"}
        subheaderText={`Количество бюджетов: ${budgetRequests.total_count}`}
        search={false}
        filters={true}
        buttonText={"Новый бюджет"}
        buttonAction={() => navigate("create")}
      />
      <Outlet />
    </>
  );
}
